"use strict";
// Duplicated from db/models/expense.ts
// To use when defining new contracts in api/contracts
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpenseStatus = void 0;
var ExpenseStatus;
(function (ExpenseStatus) {
    /** Used for bill-invoice expenses before an expense is created for invoice */
    ExpenseStatus["NOT_CREATED"] = "NOT_CREATED";
    /**
     * All expenses before switchDaySetting will have this status
     *
     * after deprecation all these will change to EXPORTED and this status removed)
     */
    ExpenseStatus["CREATED"] = "CREATED";
    /** All new expenses after switchDaySetting will get this status */
    ExpenseStatus["NOT_EXPORTED"] = "NOT_EXPORTED";
    /** Expense put in ready for export queue */
    ExpenseStatus["QUEUED"] = "QUEUED";
    /** @deprecated Expenses that are getting exported. It was used by bills export, but now bills is using the same endpoint as export dashboard */
    ExpenseStatus["EXPORTING"] = "EXPORTING";
    /** Expenses that have been exported */
    ExpenseStatus["EXPORTED"] = "EXPORTED";
})(ExpenseStatus = exports.ExpenseStatus || (exports.ExpenseStatus = {}));
//# sourceMappingURL=expense-status.js.map